import platform from 'platform';

export const isMac = platform.os?.family !== 'Windows';
export const isWindows = platform.os?.family === 'Windows';
